import guest from './rules/guest';
import user from './rules/user';
import all from './rules/all';

export default {
    guest, user, all
}